import { Component, Input, Output, signal } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { Message, ToastMessageOptions } from '../../shared';

@Component({
    selector: 'ef-import-presenter',
    templateUrl: './import-presenter.component.html',
    styleUrls: ['./import-presenter.component.scss'],
    standalone: false
})
export class ImportPresenterComponent {
    @Input() public message: string;
    @Input() public messages: ToastMessageOptions[];
    @Input() public includeInactive: boolean;
    @Output() public StartImport = new ReplaySubject<boolean>(1);
    @Output() public SetIncludeInactive = new ReplaySubject<boolean>(1);
}
